module.exports = __webpack_public_path__ + "img/icon-warning-polarlow-yellow.ae2392d5.svg";